import { render } from "./UserPortfolio.vue?vue&type=template&id=412ea638&ts=true"
import script from "./UserPortfolio.vue?vue&type=script&lang=ts"
export * from "./UserPortfolio.vue?vue&type=script&lang=ts"

import "./UserPortfolio.vue?vue&type=style&index=0&id=412ea638&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__